import React from 'react';
import logo from '../TBL Logo White.png';
import './WineryProfile.css';

const WineryProfile = ({ winery, onBack }) => {
  return (
    <div className="winery-profile">
      <div className="back-button-container">
        <button 
          className="winery-back-btn" 
          onClick={onBack}
        >
          ← Back to Winemakers
        </button>
      </div>
      <header className="winery-header">
        <img src={winery.logo} className="winery-logo-header" alt={winery.name} />
      </header>

      <div className="winery-content">
        <div className="winery-photo-section">
          <img 
            src={winery.photo} 
            alt={winery.winemakerName} 
            className="winemaker-photo"
          />
        </div>

        <div className="winery-info-section">
          <div className="winemaker-header">
            <h1>{winery.winemakerName}</h1>
            <div className="winemaker-title">
              <p className="title">{winery.title}</p>
              <p className="company">{winery.name}</p>
            </div>
          </div>

          <div className="winemaker-bio">
            {winery.bio.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>

          <div className="winery-website">
            <a 
              href={winery.websiteUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="website-link"
            >
              {winery.website}
            </a>
          </div>
        </div>
      </div>

      <div className="footer">
        <div className="footer-separator"></div>
        <img src={logo} className="footer-logo" alt="TBL Logo" />
      </div>
    </div>
  );
};

export default WineryProfile;
